import { motion } from 'framer-motion'
import { useEffect } from 'react'

import { Flex, Text } from '../../../Components'
import { cap } from '../../../State'
import { translations } from '../../../translations'
import account from '../account.png'
import nora from '../nora.png'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

const dateOptionsShort = {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: 'numeric',
  minute: 'numeric'
}
const dateOptionsLong = {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  hour: 'numeric',
  minute: 'numeric'
}

export const ChatMessages = ({ messages, brochure }) => {
  useEffect(() => {
    document.getElementById('chatMessages').scrollTo({ top: 100000, behavior: 'smooth' })
  }, [messages])
  return (
    <Flex
      id="chatMessages"
      fw
      js
      style={{ width: '100%', overflowY: 'auto', flex: 1, padding: '0px 20px', paddingBottom: 20 }}
    >
      {messages?.length > 0 && (
        <Text
          value={`${t.mcConversazioneIniziataIl} ${messages[0]?.createdAt?.toLocaleString('it-IT', dateOptionsLong)} - ${t.mcRichiestaViaggio}`}
          style={{
            color: 'var(--ink-400)',
            fontSize: 12,
            fontWeight: 300,
            marginTop: 20,
            marginBottom: 10
          }}
        />
      )}
      {messages.map((message, index) => (
        <ChatMessage key={index} message={message} brochure={brochure} />
      ))}
    </Flex>
  )
}

const ChatMessage = ({ message, brochure }) => {
  const { message: messageText = '', user, createdAt } = message
  const isNora = user === 'Nora'

  return (
    <Flex fw js>
      <Flex fw ae={!isNora} as={isNora}>
        <motion.div
          initial={{ opacity: 0, x: isNora ? -100 : 100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          style={{ width: '60%' }}
        >
          <div
            className={`nora-chat-bubble ${isNora ? 'nora-chat-bubble--nora' : 'nora-chat-bubble--user'}`}
            style={{
              display: 'flex',
              gap: 10,
              flexDirection: 'row',
              alignItems: 'flex-start',
              marginTop: 15,
              ...(brochure
                ? { background: 'var(--surface-2)', border: '1px solid var(--border)' }
                : {})
            }}
          >
            {isNora && <img src={nora} style={{ width: 40, borderRadius: '50%', flexShrink: 0 }} />}
            <Flex as style={{ flex: 1, minWidth: 0 }}>
              <Flex fw as row jb>
                <Text
                  value={user}
                  style={{ color: 'var(--ink-500)', fontSize: 12, fontWeight: 300 }}
                />
                <Text
                  value={createdAt?.toLocaleString('it-IT', dateOptionsShort)}
                  style={{ color: 'var(--ink-500)', fontSize: 12, fontWeight: 300 }}
                />
              </Flex>
              <hr style={{ width: '100%', margin: '5px 0', borderColor: 'var(--border)' }} />
              <Flex fw as>
                <Text
                  value={`${t.mcOggetto}: ${t.mcRichiestaViaggio}`}
                  style={{ color: 'var(--ink-500)', fontSize: 12 }}
                />
              </Flex>
              <hr style={{ width: '100%', margin: '5px 0', borderColor: 'var(--border)' }} />
              <Flex as>{renderMessage(messageText)}</Flex>
            </Flex>
            {!isNora && <img src={account} style={{ width: 40, flexShrink: 0 }} />}
          </div>
        </motion.div>
      </Flex>
    </Flex>
  )
}

const renderMessage = (messageText) => {
  const urlRegex = /(https?:\/\/[^\s]+[^.\s])/g
  const splitted = messageText.split(urlRegex)
  return (
    <Text
      value={splitted.map((text, index) =>
        text?.match(urlRegex) ? (
          <span key={index}>
            <a href={text} target="_blank" rel="noopener noreferrer" className="nora-chat-link">
              {t.mcApri}
            </a>
          </span>
        ) : (
          <span key={index} style={{ whiteSpace: 'pre-wrap' }}>
            {text}
          </span>
        )
      )}
    />
  )
}
